export const PropertiesProfileGalleryComponentTabsData = [
  { tab: 'Property-images' },
  { tab: 'Property-videos' },
  { tab: 'Location-images' },
  { tab: 'Location-videos' },
];
